import React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import Button from 'components/ButtonDeprecated';
import Container from 'components/Container';
import Display from 'components/Display';
import Image from 'components/Image';
import Row from 'components/Row';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import ZendeskWidget, { openWidget, useZendeskChatStatus } from 'coaching/components/ZendeskWidget';
import CoachingHelpSectionHeader from 'coaching/components/CoachingHelpFormView/CoachingHelpSectionHeader';

export default function CoachingHelpChatSection() {
  const [isChatOnline] = useZendeskChatStatus();

  return (
    <Container>
      <ZendeskWidget />
      <MediaObject figure="right">
        <Container size="xsmall" align="left">
          <Row>
            <CoachingHelpSectionHeader icon="speech-bubble-ellipses" headerText="Chat now" />
          </Row>
          <Row size="small">
            <Button
              onClick={openWidget}
              color={isChatOnline ? 'koolaid' : 'paper'}
              level="primary"
              disabled={!isChatOnline}>
              Chat with a live agent
            </Button>
          </Row>
          <Text>{CoachingConstants.COACHING_CHAT_HOURS}</Text>
        </Container>
        <Display hide="1024">
          <Image width={550} src={require('assets/images/coaching/can_phone_doodle.png')} />
        </Display>
      </MediaObject>
    </Container>
  );
}
